import axiosInstance from '../../axios-config';

const getLegalMessageApi = '/api/facilityContent/{0}/securityMessageLegal/value';
const putThreadMessagesApi = '/api/patients/{patientId}/threads/{threadId}?archivalOptions={archivalStatusOptions}';

const secureMessageApi = 'api/patients/{patientId}/SecureMessages';
const getThreadMessagesApi = secureMessageApi + '/threads/{threadId}';
const getThreadsApi = secureMessageApi + '?includeArchived={includeArchived}';
const getUnreadCountApi = secureMessageApi + '/countUnread';
const patchReviewedThreadMessagesApi = secureMessageApi + '/threads/{threadId}';
const patchUpdateThreadMemberApi = secureMessageApi + '/threads/{threadId}/member';
const postReplyToMessageApi = secureMessageApi + '/threads/{threadId}/reply';
const sendSecureMessageApi = secureMessageApi + '/new/{careProviderId}';

export const getLegalMessage = (facilityId) =>
  axiosInstance.get(getLegalMessageApi.replace('{0}', facilityId));

export const postSecureMessage = (params) => {
  const jsonData = {
    subject: params.subjectText,
    content: params.messageText,
  };
  return axiosInstance.post(
    sendSecureMessageApi
      .replace('{patientId}', params.patientId)
      .replace('{careProviderId}', params.careProviderId),
    jsonData,
    { headers: { 'Content-Type': 'application/json' } }
  );
};

export const getThreads = (patientId) =>
  axiosInstance.get(getThreadsApi
    .replace('{patientId}', patientId)
    .replace('{includeArchived}', 'true')
  );

export const getThreadMessages = (patientId, threadId) =>
  axiosInstance.get(getThreadMessagesApi
    .replace('{patientId}', patientId)
    .replace('{threadId}', threadId)
  );

export const putThread = (patientId, threadId, archive) =>
  axiosInstance.put(putThreadMessagesApi
    .replace('{patientId}', patientId)
    .replace('{threadId}', threadId)
    .replace('{archivalStatusOptions}', archive)
  );

export const getUnreadCount = (patientId) =>
  axiosInstance.get(getUnreadCountApi
    .replace('{patientId}', patientId));

export const patchReviewedThreadMessages = (patientId, threadId, threadMemberId, messages) => {
  if (!Array.isArray(messages) || !messages.length) {
    return null;
  }

  const jsonData = messages.map((currentMsg) =>
    ({
      op: 'replace',
      path: '/Member=' + threadMemberId + '/Message=' + currentMsg.messageId + '/Reviewed',
      value: '',
    })
  );

  return axiosInstance.patch(
    patchReviewedThreadMessagesApi
      .replace('{patientId}', patientId)
      .replace('{threadId}', threadId),
    jsonData,
    {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    }
  );
};

export const patchThreadMember = (patientId, threadId, isArchived) => {
  const jsonData = [{
    op: 'replace',
    path: '/isArchived',
    value: isArchived,
  }];

  return axiosInstance.patch(
    patchUpdateThreadMemberApi
      .replace('{patientId}', patientId)
      .replace('{threadId}', threadId),
    jsonData,
    {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    }
  );
};

export const postReplyToMessage = (patientId, threadId, replyText) => {
  const jsonData = {
    content: replyText,
  };
  return axiosInstance.post(
    postReplyToMessageApi
      .replace('{patientId}', patientId)
      .replace('{threadId}', threadId),
    jsonData,
    { headers: { 'Content-Type': 'application/json' } }
  );
};
